import React, { MouseEventHandler, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import Icon from './Icon';
import Link from './Link';

export enum InfoBoxType {
    Alert,
    Info,
    Warning,
}

const bgColorByType: Record<InfoBoxType, string> = {
    [InfoBoxType.Alert]: 'bg-red',
    [InfoBoxType.Info]: 'bg-gray-200',
    [InfoBoxType.Warning]: 'bg-yellow-100',
};

const textColorByType: Record<InfoBoxType, string> = {
    [InfoBoxType.Alert]: 'text-black dark:text-white',
    [InfoBoxType.Info]: 'text-gray-800',
    [InfoBoxType.Warning]: 'text-gray-800',
};

interface Props {
    children: ReactNode;
    type: InfoBoxType;
    linkText?: string;
    onClickLink?: MouseEventHandler;
    className?: string;
}

const InfoBox = ({
    children,
    type,
    linkText,
    onClickLink,
    className,
}: Props) => (
    <div
        className={twMerge(
            'flex grow gap-2 rounded-sm px-4 py-2',
            bgColorByType[type],
            textColorByType[type],
        )}
    >
        <Icon iconKey="info" className="size-5" />
        <div className={twMerge('self-center', className)}>
            {children}

            {linkText && onClickLink ? (
                <>
                    &nbsp;<Link onClick={onClickLink}>{linkText}</Link>
                </>
            ) : null}
        </div>
    </div>
);

export default InfoBox;
